/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Scorepercent1Inputs */

const en__field_scorepercent1 = /** @type {(inputs: _Field_Scorepercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score (%)`)
};

/**
* | output |
* | --- |
* | "Score (%)" |
*
* @param {_Field_Scorepercent1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_scorepercent1 = /** @type {((inputs?: _Field_Scorepercent1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Scorepercent1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_scorepercent1(inputs)
});
export { _field_scorepercent1 as "_field_scorePercent" }